<template>
  <div class="file-preview">
    <template v-if="previewData.fileType === 'docx'">
      <word-preview :preview-data="previewData"></word-preview>
    </template>

    <template v-if="previewData.fileType === 'xlsx'">
      <excel-preview :preview-data="previewData"></excel-preview>
    </template>

    <template v-if="previewData.fileType === 'pptx'">
      <ppt-preview :preview-data="previewData" @render="handleRender"></ppt-preview>
    </template>

    <template v-if="previewData.fileType === 'pdf'">
      <pdf-preview :preview-data="previewData"></pdf-preview>
    </template>

    <template v-if="imageType.includes(previewData.fileType)">
      <image-preview :preview-data="previewData"></image-preview>
    </template>

    <template v-if="previewData.fileType === 'mp4' || previewData.fileType === 'webm'">
      <video-preview :preview-data="previewData"></video-preview>
    </template>

    <!-- 不支持文件类型 -->
    <template v-if="!supportType.includes(previewData.fileType)">
      <not-support :preview-data="previewData"></not-support>
    </template>
  </div>
</template>

<script>
import common from "@/mixins/common";
import wordPreview from "@/packages/wordPreview";
import excelPreview from "@/packages/excelPreview";
import pptPreview from "@/packages/pptPreview";
import pdfPreview from "@/packages/pdfPreview";
import imagePreview from "@/packages/imagePreview";
import videoPreview from "@/packages/videoPreview";
import notSupport from "@/components/notSupport";
import { EventBus } from "@/utils/eventBus";

export default {
  name: "filePreview",
  components: {
    wordPreview,
    excelPreview,
    pptPreview,
    pdfPreview,
    imagePreview,
    videoPreview,
    notSupport
  },
  mixins: [common],
  data() {
    return {
      supportType: ['docx', 'xlsx', 'pptx', 'pdf', 'jpg', 'png', 'jpeg', 'bmp', 'gif', 'mp4', 'webm'],
      imageType: ['jpg', 'png', 'jpeg', 'bmp', 'gif']
    }
  },
  mounted() {
    EventBus.$on('close', () => {
      this.$emit('close');
    });
  },
  methods: {
    handleRender() {
      this.$emit('render');
    }
  },
  beforeDestroy() {
    EventBus.$off('close');
  }
}
</script>

<style lang="scss">
.lls-loading-mask {
  background: rgba(0,0,0, 0.7) !important;
}
</style>
